import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import { isPlainLeftClick } from "../../View/ProductHybrid/productOverlay/productOverlayContext";
import { useOpenProduct } from "../../View/ProductHybrid/productPageOverlay/overlayNavigation";

const isCurrentPage = (to, location) => {
  const url = new URL(String(to), window.location.origin + location.pathname);
  return `${url.pathname}${url.search}`.toLowerCase() === `${location.pathname}${location.search}`.toLowerCase();
};

export const ProductLink = ({ to, onClick, target, children, ...rest }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const openProduct = useOpenProduct(isAuthenticated === true);

  const handleClick = (event) => {
    onClick?.(event);
    if (!to || !isPlainLeftClick(event) || (target && target !== "_self")) return;
    if (isCurrentPage(to, location)) {
      event.preventDefault();
      return;
    }
    if (event.defaultPrevented) return;
    event.preventDefault();
    openProduct(to);
  };

  return (
    <Link to={to} target={target} onClick={handleClick} {...rest}>
      {children}
    </Link>
  );
};
